export default {
  DOWNLOAD_REPORTS_PACK_REQUEST: 'DOWNLOAD_REPORTS_PACK_REQUEST',
  DOWNLOAD_REPORTS_PACK_SUCCESS: 'DOWNLOAD_REPORTS_PACK_SUCCESS',
  DOWNLOAD_REPORTS_PACK_FAILURE: 'DOWNLOAD_REPORTS_PACK_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/download-report-page/actions/action-types.js